// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { GridItemProps } from "@insite/mobius/GridItem";
import { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

interface OrderInfoStyle {
    orderWrapper?: GridItemProps;
    orderGridItems?: GridItemProps;
    titleText?: TypographyProps;
    orderLabel?: InjectableCss;
    orderValue?: InjectableCss;
    mainInformationGridContainer?: InjectableCss;
}

export const orderInfoStyle: OrderInfoStyle = {
    titleText: {
        variant: "h2",
        as: "h1",
        css: css`
            margin: 50px 0 40px 0;
        `,
    },
    orderGridItems: {
        css: css`
            @media print {
                padding: 15px !important;
            }
        `,
    },
    orderWrapper: {
        width: 12,
        css: css`
            display: inline-flex;
            align-items: center;
            margin-bottom: 0;
        `,
    },
    orderLabel: {
        css: css`
            margin-bottom: 0;
            font-weight: bold;
            font-size: 15px;
            white-space: nowrap;

            &:after {
                content: ":";
            }
        `,
    },
    orderValue: {
        css: css`
            margin-left: 5px;
            font-size: 15px;
        `,
    },
    mainInformationGridContainer: {
        css: css``,
    },
};
